

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import TataProposal from '../../life-config/proposalConfig/tataProposalConfig.json';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import tataBIJsonData from '../../life-config/biConfig/tataBiConfig.json';




@Component({
    selector: 'app-limited-pay',
    templateUrl: './limited-pay.component.html',
    styleUrls: ['./limited-pay.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class LimitedPayComponent implements OnInit {

    productType: object = lifeProductType.product_type;
    tataProposalInfo: any = TataProposal.TataProposalFormInitialJson;
    TataBIJson: any = tataBIJsonData.TatabiInitialJson;
    limitedPayForm: FormGroup;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    proposalCompTransferVal: any;
    uuid: string;
    proposalId: string;
    proposalInitalResponse: any;
    proposalRes: any;
    premiumTermVal: string | number;
    limitedPayList: any[] = [];
    reCalPremiumRes: any;
    uiDobVal : Date;
    premiumPaymentTypeToSend: number;


    constructor(

        private apiService: ApiService,
        private formbuild: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private sharedApi: SharedApiService,
        private datePipe: DatePipe,

    ) {

        /**
         * Form control name
         */
        this.limitedPayForm = this.formbuild.group({

            limitedPayVal: [this.TataBIJson['Limited Pay']['default']],

        });

       // this.limitedPayList = this.TataBIJson['Limited Pay']['limitedPayList'];



        this.sharedApi.invokeProposalEvent.subscribe(value => {
            if (value) {

                this.proposalRes = value;
                this.feedLimitedval();

            }
        });

        /**
         * Get updated DOB value on user change to feed in limited pay
         */
        this.sharedApi.invokeUIDob.subscribe(value => {
            if (value) {

                this.uiDobVal = value;

            }
        });

    }


    // get Proposal Form <- check this if requeried then keep it otherwise remove it


    feedLimitedval() {
        /**
         * Check premium payment type
         */
        this.limitedPayList = this.proposalRes['available_plans_set'];

        if (this.proposalRes['premium_payment_type']) {
            this.limitedPayList.forEach((element) => {


                if (element['premiumPaymentType'] === this.proposalRes['premium_payment_type']) {

                    /**
                     * check premium payment term
                     */
                    if ( element['value'] === this.proposalRes['premium_term'] ) {

                        this.limitedPayForm.patchValue({ limitedPayVal: element['value'] });

                    }
                }
            });

        }
     
    }

    
    // Limited pay

    limitedPayInvoked(evnt: any) {

        const retrievedEvent = evnt.value;

        if (retrievedEvent === 1) {
            this.premiumTermVal = this.proposalRes['policy_term'];
            this.premiumPaymentTypeToSend = this.TataBIJson['premiumPaymentVal']['regular'];
            /**
             * On proposal response,value feed dob and get date
             */
            // const ageObtained =  this.sharedApi.getAgeInyears(  this.proposalRes['lifeassured']['dob']);

        } else if (retrievedEvent === 60) {

            this.premiumTermVal = retrievedEvent - (this.sharedApi.getAgeInyears(this.proposalRes['lifeassured']['dob']));
            if(this.premiumTermVal < 0) {
                this.premiumTermVal = 0;
            }
            this.premiumPaymentTypeToSend = this.TataBIJson['premiumPaymentVal']['payTillSixty'];


        } else {
            this.premiumTermVal = retrievedEvent;
            this.premiumPaymentTypeToSend = this.TataBIJson['premiumPaymentVal']['limited'];
        }

        const data = {
            premium_term: this.premiumTermVal,
            coverage_age : this.proposalRes['coverage_age'],
            premium_payment_type : this.premiumPaymentTypeToSend,
            // dob: this.datePipe.transform(new Date( this.uiDobVal), 'yyyy-MM-dd'),
        };


        // tslint:disable-next-line: max-line-length
        this.apiService.updateProposal(this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['update_proposal'], data).subscribe(res => {

            // To get updated premium
            if (res) {

                /**
                 * call for proposla response to feed in limuited val
                 */
                this.proposalRes = res;
              

                this.sharedApi.getRecalculatedPremium(this.proposalId, this.uuid).subscribe(calRes => {

                this.reCalPremiumRes =  calRes;
                this.feedLimitedval();

                if (this.reCalPremiumRes) {

                    this.sharedApi.callMethodOfSecondComponent(this.reCalPremiumRes);
                    this.sharedApi.getBenefitIllustration(this.proposalId, this.uuid).subscribe(BIres => {
                        if (BIres) {

                            this.sharedApi.callMethodForBIComponent(BIres);

                        }

                    });
                }


               });

            }


        });
    }







    // Getting UUID  and Propoal ID from  queryparams

    ngOnInit() {

        this.activatedRoute.params.subscribe(params => {

            this.proposalId = params['proposalId'];
            this.uuid = params['uuid'];

        });




    }

}










